import React, { useCallback, useMemo } from 'react';
import { PeopleTeamsAnalyticsContext } from '@atlaskit/analytics-namespaced-context';
import { createTeamsExperienceTracker } from './experiences';
import { useAnalyticsEvents } from './generated/use-analytics-events';
import { useAnalyticsEventsWithTags } from './use-analytics-events-with-tags';
const defaultAnalyticsContextData = {
  packageName: "@atlassian/people-teams-ui",
  packageVersion: "2.13.3"
};
export function WrappedPeopleTeamsAnalyticsProvider({
  analyticsContextData,
  children
}) {
  const data = useMemo(() => {
    if (typeof analyticsContextData === 'object') {
      return {
        ...defaultAnalyticsContextData,
        ...analyticsContextData
      };
    }
    return defaultAnalyticsContextData;
  }, [analyticsContextData]);
  return /*#__PURE__*/React.createElement(PeopleTeamsAnalyticsContext, {
    data: data
  }, children);
}
export const usePeopleTeamAnalyticsEvents = () => useAnalyticsEvents();
export const usePeopleTeamAnalyticsEventsWithTags = () => useAnalyticsEventsWithTags();
export const useTeamsExperienceTracker = () => {
  const {
    fireEvent
  } = usePeopleTeamAnalyticsEvents();
  const fireExperienceEvent = useCallback((action, subject, attributes) => {
    // @ts-ignore TODO: we may need to declare the keys to a const in the types file so we can do a check here
    fireEvent(`operational.${subject.replace(/[\/-]/g, '_')}.${action}`, {
      ...attributes,
      source: 'clientMetrics'
    });
  }, [fireEvent]);
  const experienceTracker = useMemo(() => createTeamsExperienceTracker(fireExperienceEvent), [fireExperienceEvent]);
  return experienceTracker;
};